import { ClockWidget } from '../components/widgets/ClockWidget';
import { ExpiringWidget } from '../components/widgets/ExpiringWidget';
import { NotesWidget } from '../components/widgets/NotesWidget';
import { ShoppingWidget } from '../components/widgets/ShoppingWidget';
import { WasteWidget } from '../components/widgets/WasteWidget';
import { TodayWidget } from '../components/widgets/TodayWidget';
import { WeatherWidget } from '../components/widgets/WeatherWidget';
import { kicker } from '../theme';
import { useWasteFeedIds } from '../store';

/**
 * The dashboard.
 *
 * A fixed grid of sized slots rather than a drag-and-drop board: a wall panel
 * is arranged once and then never touched, so free-form layout would mostly
 * buy the freedom to make it ugly. Which widget sits in which slot becomes
 * configurable later; the proportions stay designed.
 *
 * Everything here has to be readable from across the kitchen — one big figure
 * per tile, detail on tap.
 */
export function Overview() {
  // The bin tile only exists once a waste calendar does; without one it would
  // be a permanently empty box asking to be configured.
  const hasWaste = useWasteFeedIds().size > 0;

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '34px 38px 0', minHeight: 0 }}>
      <div style={{ flex: 'none' }}>
        <div style={kicker}>ÜBERSICHT</div>
        <div
          style={{
            fontSize: 52,
            fontWeight: 500,
            letterSpacing: '-0.045em',
            lineHeight: 1.1,
            marginTop: 6,
          }}
        >
          Zuhause
        </div>
      </div>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          marginTop: 24,
          paddingBottom: 30,
          display: 'grid',
          gap: 14,
          // Three columns, never four: these tiles are mostly lists of item
          // names, and a fourth column truncates them to "Hähnche…". The bin
          // tile earns a third row instead of squeezing the rest.
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gridTemplateRows: hasWaste ? 'repeat(3, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))',
          gridTemplateAreas: hasWaste
            ? `"weather expiring today"
               "weather waste    shopping"
               "clock   notes    notes"`
            : `"weather expiring today"
               "clock   notes    shopping"`,
        }}
      >
        {/* Weather goes tall when there is room: the hourly strip is the part
            that benefits, and the tile is the only one with vertical content. */}
        <div style={{ gridArea: 'weather', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <WeatherWidget />
        </div>
        <div style={{ gridArea: 'expiring', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ExpiringWidget />
        </div>
        <div style={{ gridArea: 'today', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <TodayWidget />
        </div>
        <div style={{ gridArea: 'clock', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ClockWidget />
        </div>
        <div style={{ gridArea: 'notes', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <NotesWidget />
        </div>
        <div style={{ gridArea: 'shopping', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ShoppingWidget />
        </div>
        {hasWaste && (
          <div style={{ gridArea: 'waste', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <WasteWidget />
          </div>
        )}
      </div>
    </div>
  );
}
